import { render, staticRenderFns } from "./Mixed.vue?vue&type=template&id=80070406&scoped=true&"
import script from "./Mixed.vue?vue&type=script&lang=js&"
export * from "./Mixed.vue?vue&type=script&lang=js&"
import style0 from "./Mixed.vue?vue&type=style&index=0&id=80070406&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80070406",
  null
  
)

export default component.exports